module.exports = __webpack_public_path__ + "img/kormanyvaltasig_nem_szulok_3.388008d4.jpg";